import {Component, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {HwCatalogService} from "../../../../services/hw-catalog.service";
import {DefaultDeviceCatalog} from "../../../../model/default-device-catalog";

@Component({
  selector: 'app-default-devices-details',
  templateUrl: './default-devices-details.component.html',
  styleUrls: ['./default-devices-details.component.scss']
})
export class DefaultDevicesDetailsComponent implements OnInit {

  public navState: any;

  public defaultDeviceCatalog: DefaultDeviceCatalog;

  public items: MenuItem[];
  public activeItem: MenuItem;
  public activeItemIndex: number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private hwCatalogService: HwCatalogService,
              private translocoService: TranslocoService) {
    const navigation = this.router.getCurrentNavigation();
    this.navState = navigation?.extras.state;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.loadTemplate(params.uuid));

    this.items = [
      {id: 'overview', label: 'common.overview', icon: 'pi pi-home'},
      {id: 'sensors', label: 'model.sensors', icon: 'pi pi-wifi'},
      {id: 'properties', label: 'model.properties', icon: 'pi pi-bars'},
      {id: 'integrationModules', label: 'model.integrationModules', icon: 'pi pi-table'}
    ];
    this.loadItems();
  }

  loadTemplate(uuid: string): void {
    this.hwCatalogService.getDefaultDeviceCatalog(uuid).subscribe(response => {
      this.defaultDeviceCatalog = response.defaultDeviceCatalog;
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

  private loadItems() {
    this.items.forEach(item => {
      this.translocoService.selectTranslate(item.label).subscribe(value => {
        return item.label = value;
      });
    });

    if (this.navState && this.navState.showView) {
      this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
      this.activeItem = this.items[this.activeItemIndex];
    } else {
      this.activeItemIndex = 0;
      this.activeItem = this.items[this.activeItemIndex];
    }
  }

}
